import {Injectable} from '@angular/core';
import { Http, Response, Headers, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';


import 'rxjs/add/operator/map';

@Injectable()
export class AuthService {
  public token: string;
  private API_URL = environment.API_URL;


  constructor(private http: Http, private router: Router) {}

  requestLogin(credentials) {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' });

    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify(credentials);
    return this.http.post(this.API_URL + '/api/login', body, headers).map((res: Response) => res.json());
  }

  createAuthorizationHeader(headers: Headers) {
    const authHeader = JSON.parse(localStorage.getItem('currentUser')).authHeader;
    headers.append('Authorization', authHeader);
  }

  login(username: string, password: string): Observable<any> {
    return this.http.post(this.API_URL + '/api/login', JSON.stringify({ username: username, password: password }))
      .map((response: Response) => {
        // login successful if there's a jwt token in the response
        const token = response.json();
        if (token) {
          this.token = token;
          // store username and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify({ username: token.user.username, session: token.session, authHeader: token.authHeader }));
          // return true to indicate successful login
          return token;
        } else {
          // return false to indicate failed login
          return false;
        }
      });
  }

  getCurrentUserRoles(): Observable<any> {
    const headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(this.API_URL + '/api/users/roles', { headers: headers }).map((res: Response) => res.json());
  }

  logout(): void {
    // clear token remove user from local storage to log user out
    console.log('logout');
    this.token = null;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentView');
    this.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/services/auth.service.ts